import { v4 as UUID } from 'uuid'
import { ruutsApi } from '../../services/ruutsApi'
import { sortSiteNamesNumerically } from './sortUtils'

export type Strata = GeoJSON.Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon>

export interface PointProperties {
  name?: string
  strata?: string
  seed?: number
  randomIteration?: number
  timestamp?: string
  samplingAreaId?: string
  farmId?: string
  isRandomSite?: boolean
  randomizeCounter?: number
  randomizeReason?: string[]
  // Identidad estable de cliente para el key de React. Un sitio sin guardar no tiene `id`,
  // así que sin esto el key cae en el nombre y editarlo remonta la fila (pierde el foco).
  clientId?: string
}

export type PointFeature = GeoJSON.Feature<GeoJSON.Point, PointProperties>

export default async function randomPointsInPolygonV4({
  samples,
  strata,
  samplingAreaId,
  initialIndex = 1,
}: {
  samples: number
  strata: Strata
  samplingAreaId: string
  initialIndex?: number
}): Promise<PointFeature[]> {
  if (!samplingAreaId) {
    throw new Error('Randomizer v4 requires a samplingAreaId.')
  }

  try {
    const generatedSites = await ruutsApi.randomizeV4Generate({ samplingAreaId, samples })

    const normalizedSites: PointFeature[] = generatedSites.map((site, idx) => ({
      type: 'Feature',
      geometry: site.geometry,
      properties: {
        clientId: UUID(),
        seed: site.seed,
        timestamp: site.createdAt,
        name: `${strata.properties.name}-${initialIndex + idx}`,
        strata: strata.properties.name,
        samplingAreaId: site.samplingAreaId,
        farmId: site.farmId,
        randomIteration: idx + 1,
        randomizeCounter: 0,
        randomizeReason: [],
        isRandomSite: true,
      },
    }))

    const sortedSites = sortSiteNamesNumerically(normalizedSites)

    return sortedSites
  } catch (error) {
    throw new Error(
      `Error al generar puntos aleatorios: ${error instanceof Error ? error.message : 'Error desconocido'}`,
    )
  }
}
